import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const InputTextarea = forwardRef(
  (
    {
      className,
      defaultValue,
      disabled,
      id,
      maxLength = 250,
      onChange,
      placeholder,
      rows = 5,
      state = 'default',
      ...props
    },
    ref,
  ) => {
    const classNames = useClassNames(
      () => [
        'w-full resize-none rounded px-3 py-2 text-slate-800 placeholder-slate-500 ring-1 ring-inset ring-slate-200 focus:outline-none focus:ring-1 focus:ring-inset focus:ring-blue-500',
        !disabled && state === 'invalid' && 'ring-1 ring-red-600',
        !disabled && state === 'invalid' && 'ring-1 text-red-600',
        !disabled && state === 'valid' && 'ring-1 ring-green-500',
        !disabled && state === 'valid' && 'ring-1 text-green-500',
        className,
      ],
      [disabled, className, state],
    );
    return (
      <textarea
        id={id}
        ref={ref}
        defaultValue={defaultValue}
        className={classNames}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        onChange={({ target }) => onChange(target.value)}
        {...props}
      />
    );
  },
);

InputTextarea.displayName = 'InputTextarea';

InputTextarea.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any,
    }),
  ]),
  rows: PropTypes.number,
  state: PropTypes.oneOf(['default']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default InputTextarea;
